import { Box, useMediaQuery, useTheme, Grid2 as Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import InspirationDetailsData from "./data.json";
import NotFound from "../../../../components/NotFound/not-found";
import './inspiration-details.css';

const imagesPath = "/assets"

export default function InspirationDetails() {
  const [data, setData] = useState(null);
  const { topic } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const widthText = isMobile ? "100%" : "75%";

  const navigate = useNavigate();

  const handleClick = ({ path }) => {
    if (path) {
      navigate(path);
    }
  };

  useEffect(() => {
    const getDetails = async () => {
      const topicData = InspirationDetailsData.find(item => item.topic === topic);
      if (topicData) {
        setData(topicData);
      } else {
        setData(null); // Handle case where topic is not found
      }
    }
    getDetails();
  }, [topic]);

  if (!data) {
    return <NotFound />;
  }

  return (
    <Box sx={{ py: 6, px: 2 }} className="inspiration-details-container">
      <Grid container spacing={3} >
        <Grid item size={{ xs: 12, sm: 12, md: 5, lg: 5 }} offset={{ xs: 0, sm: 0, md: 2, lg: 2 }} className="inspiration-details__text-container">
          <Box sx={{ width: widthText, mx: "auto", textAlign: "left" }} className="inspiration-details-content">
            <Typography variant="h6" className="inspiration-details-smalltitle">
              {data.smallTitle}
            </Typography>
            <Typography variant="h4" className="inspiration-details__title" >{data.title}</Typography>
            <Typography variant="body1" className="inspiration-details__subtitle inspiration-details__body text--bold color--red">{data.subtitle}</Typography>
          </Box>
          <Box sx={{ width: widthText, mx: "auto", textAlign: "left", mt: 2 }} className="inspiration-details-description">
            <Typography variant="body1" className="inspiration-details__body" dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </Box>
          <Box sx={{ width: widthText, mx: "auto", textAlign: "left", mt: 2 }} className="inspiration-details-list">
            <ul className="inspiration-details__body pl-1">
              {data.list.map((item, index) => (
                <li key={index} style={{ marginBottom: "20px" }}>
                  <strong className= "inspiration-details__paragraph-title" dangerouslySetInnerHTML={{ __html: item.title }}></strong> <span dangerouslySetInnerHTML={{ __html: item.description }}></span>
                </li>
              ))}
            </ul>
          </Box>
          <Box sx={{ width: widthText, mx: "auto", textAlign: "left", mt: 2 }} className="inspiration-details-description">
            <Typography variant="body1" className="inspiration-details__body" dangerouslySetInnerHTML={{ __html: data.prefooter }}
            />
          </Box>
          <Box className="inspiration-details__footer-text">
            <Typography variant="body1" className="text--bold color--red text--title" dangerouslySetInnerHTML={{ __html: data.footer }} />
          </Box>
        </Grid>
        <Grid item xs={12} size={{ xs: 12, sm: 12, md: 5, lg: 5 }} className="inspiration-details__images-container">
          <Box className="inspiration-details__images">
            {data.images && data.images[0] && (
              <Box
                component="img"
                src={`${imagesPath}/inspiration/${data.images[0].src}`}
                alt={data.images[0].alt}
                className="inspiration-details__image inspiration-details__image--large"
              />
            )}
          </Box>
          <Box className="inspiration-details__images-row">
            {data.images && data.images.slice(1, 3).map((image, index) => (
              <Box
                key={index + 1}
                component="img"
                src={`${imagesPath}/inspiration/${image.src}`}
                alt={image.alt}
                className="inspiration-details__image inspiration-details__image--small"
              />
            ))}
          </Box>
        </Grid>
        <Box className="inspiration-details__footer">
          <Box className="inspiration-details__footer-products">
            <Typography variant="h4" className="inspiration-details__footer-title">
              ✧ Productos ✧
            </Typography>
            <Box className="inspiration-details__footer-products-list">
              {data.products.filter(product => product.status).map((product, index) => (
                <Box key={index} className="inspiration-details__footer-product">
                  <Box
                    component="img"
                    src={`${imagesPath}/products/${product.image}`}
                    alt={product.name}
                    className="inspiration-details__footer-product-image"
                    onClick={() => handleClick({ path: product.link })}

                  />
                  <Typography variant="h5" className="inspiration-details__footer-product-name">
                    {product.name}
                  </Typography>
                  <Typography variant="body1" className="inspiration-details__footer-product-description">
                    {product.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Grid>
    </Box>
  );
}